import { render, staticRenderFns } from "./GroupOverview.vue?vue&type=template&id=421b3271&scoped=true"
import script from "./GroupOverview.vue?vue&type=script&lang=js"
export * from "./GroupOverview.vue?vue&type=script&lang=js"
import style0 from "./GroupOverview.vue?vue&type=style&index=0&id=421b3271&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "421b3271",
  null
  
)

/* custom blocks */
import block0 from "./GroupOverview.vue?vue&type=custom&index=0&blockType=i18n"
if (typeof block0 === 'function') block0(component)

export default component.exports